import { makeStyles, Theme } from '@material-ui/core/styles';

export const makePaperStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: '2rem 3rem',

        [theme.breakpoints.down('xs')]: {
            padding: '2rem 1.5rem',
        },
    },
    noPadding: {
        [theme.breakpoints.down('sm')]: {
            padding: 0,
        }
    },
}));
